import * as Yup from "yup";
import { yupRequiredDate, yupRequiredString } from "../yup/Validators";

export const BookingBillingValidationSchema = Yup.object().shape({
  number: yupRequiredString,
  file: yupRequiredString,
  invoiceDate: yupRequiredDate,
})
